import { render, staticRenderFns } from "./caseStatistics.vue?vue&type=template&id=6f399b4e&scoped=true"
import script from "./caseStatistics.vue?vue&type=script&lang=js"
export * from "./caseStatistics.vue?vue&type=script&lang=js"
import style0 from "./caseStatistics.vue?vue&type=style&index=0&id=6f399b4e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f399b4e",
  null
  
)

export default component.exports